export const AUTH_SOURCE_TYPE_PULSE = 'pulse';
export const AUTH_SOURCE_TYPE_SPID = 'spid';

export default {
    AUTH_SOURCE_TYPE_PULSE,
    AUTH_SOURCE_TYPE_SPID,
};
